<template>
  <b-offcanvas
    v-model="visibleModel"
    :placement="right ? 'end' : 'start'"
    :backdrop="backdrop"
    :no-header="noHeader"
    :body-class="sidebarClass"
    @hidden="$emit('hidden')"
  >
    <slot :hide="hide" />
  </b-offcanvas>
</template>

<script>
export default {
  name: 'BSidebar',
  inheritAttrs: false,
  props: {
    visible: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
    backdrop: { type: Boolean, default: false },
    shadow: { type: Boolean, default: false },
    noHeader: { type: Boolean, default: false },
    sidebarClass: { type: String, default: '' },
    bgVariant: { type: String, default: '' },
  },
  emits: ['hidden', 'change', 'update:visible'],
  data() {
    return { internal: this.visible }
  },
  computed: {
    visibleModel: {
      get() {
        return this.internal
      },
      set(v) {
        this.internal = v
        this.$emit('change', v)
        this.$emit('update:visible', v)
      },
    },
  },
  watch: {
    visible(v) {
      this.internal = v
    },
  },
  methods: {
    hide() {
      this.visibleModel = false
    },
  },
}
</script>
